<template>
  <div class="scroll-wrapper">
    <div class="billing-wrapper">
      <table class="billing" cellpadding="0" cellspacing="0">
        <thead>
          <tr>
            <th v-html="texts.table[0].title" />
            <th v-html="texts.table[1].title" />
            <th v-html="texts.table[2].title" />
            <th v-html="texts.table[3].title" />
            <th>
              <img
                v-if="transactionsLoading"
                class="loading"
                src="/images/loading.gif"
                alt="loading"
              />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="invoice in invoices">
            <td>{{ invoice.invoiceId }}</td>
            <td class="opacity-50">
              USD
              {{
                new Intl.NumberFormat('en-US', {
                  style: 'currency',
                  currency: 'USD',
                  minimumFractionDigits: 0
                }).format(invoice.amount / 100)
              }}
            </td>
            <td class="opacity-50">
              {{ new Date(invoice.billDate * 1000).toLocaleDateString() }}
            </td>
            <td>
              <div class="status">
                <template v-if="invoice.datePaid">
                  <div class="status-tag"><span v-html="TickSvg" />Paid</div>
                </template>
                <template v-else>
                  <div class="status-tag not-paid">
                    <span v-html="XSvg" />Not paid
                  </div>
                </template>
              </div>
            </td>
            <td class="opacity-50"></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import DownloadSvg from '~/assets/icons/download.svg?raw'
import TickSvg from '~/assets/icons/tick.svg?raw'
import XSvg from '~/assets/icons/x.svg?raw'

const textsStore = useTextsStore()
const deployerStore = useDeployerStore()
const texts = computed(() => textsStore.account.billing.box_history)

const props = defineProps({
  transactions: [Array, Boolean],
  transactionsLoading: {
    type: Boolean,
    default: false
  }
})

const invoices = computed(() => {
  return props.transactions.sort((a, b) => b.dateCreated - a.dateCreated)
})
</script>

<style lang="scss" scoped>
.scroll-wrapper {
  overflow-x: auto;
  max-width: calc(100dvw - 60px);
}

.billing-wrapper {
  min-width: 600px;
}

.billing {
  width: 100%;
  border-radius: 10px;
  border: 1px solid var(--bubble-10, rgba(0, 0, 0, 0.1));
  overflow: hidden;
  text-align: left;
  thead {
    background: var(--Banner-5, rgba(0, 0, 0, 0.05));
  }

  td,
  th {
    padding: 18px 0 15px 0;
    font-size: 1.5rem;
    font-weight: 500;

    &:nth-child(1) {
      padding-left: 20px;
      width: 50%;
      @media (max-width: 1023px) {
        width: auto;
      }
    }
  }

  th {
    opacity: 0.5;
  }

  tr {
    td {
      border-top: 1px solid var(--bubble-10, rgba(0, 0, 0, 0.1));
    }
  }

  .loading {
    max-height: 20px;
  }
}

.status-tag {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 5px;
  border-radius: 5px;
  background: #e1dcff;
  color: #654cff;
  line-height: 100%;

  &.not-paid {
    background: #fde7e7;
    color: #ff4d4f;
  }
}

.download {
  :deep(path) {
    stroke: var(--Text, #000);
  }
}
</style>
